import { render, staticRenderFns } from "./topWidget.vue?vue&type=template&id=d0ffff1a&"
import script from "./topWidget.vue?vue&type=script&lang=js&"
export * from "./topWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports